import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import i18n from './i18n'

Vue.use(Vuex)

const TokenKey = 'Admin-Token'
const RolesKey = 'Admin-Roles'
const NameKey = 'Admin-Name'
const UsernameKey = 'Admin-Username'
const I18nLocaleKey = 'Admin-I18nLocale' //保存语言设置（中英文）

export default new Vuex.Store({
  state: {
    //用户信息，每次刷新页面重新获取
    user: {
      username: '', //用户名
      name: '', //姓名
      roles: '', //角色代码
      resource: [], //资源
      organization: '', //组织机构
      dataQueryOrganizationPrefix: '', //数据查询组织前缀
      userId: '', //用于id
      mainPage: '', //主页面，默认页面
      idcard: '', //证件号码
      type: '', //0系统内账户，1客户账户
      customerId:''
    },
    //token 用户token,实现token登录，也将会保存在cookies中
    token: getToken(),
    // 国家化多语言设置，也将会保存在cookies中
    i18nLocale: getI18nLocale(),
    other: {}, // 用于各组件的数据交互使用
	isUnfold: false,//是否展开菜单
    searchParams:{
        pageSize:10,
        pageNum:1,
        dept:'',
        needEquip: '',
        childDept: '',
        name:'',
        gw:''
    }
  },
  mutations: {
    // 更新用户信息
    updateUser(state, payload) {
      Object.assign(state.user, payload)
    },
    // 保存token
    setToken(state, token) {
      if (token) {
        state.token = token
        setToken(token)
      }
    },
    // 退出，清空用于信息
    logout(state) {
      Object.assign(state.user, { username: '', name: '', roles: [], resource: [],zw:'',zwcj:'' })
      state.token = ''
      removeToken()
    },
    // 修改国际化语言状态
    updateI18Locale(state, locale) {
      state.i18nLocale = locale
      setI18nLocale(locale as any)
    },
    // 保存信息在other，主要用于组件间的数据传递
    setOther(state, info) {
      Object.assign(state.other, info)
    },
    clearOther(state) {
      state.other = {}
    },
	// 更新菜单状态
	updateUnfold(state, status) {
	  state.isUnfold = status;
	},
    updateSearchParams(state,value){
      state.searchParams=value
    }
  },
  // 通过this.$stroe.getters.xxx的方式可以快速获取状态值
  getters: {
	isUnfold: state => state.isUnfold, //菜单状态
    token: state => state.token,
    user: state => state.user,
    name: state => state.user.name,
    roles: state => state.user.roles,
    username: state => state.user.username,
    resource: state => state.user.resource,
    i18nLocale: state => state.i18nLocale,
    // 获取配置菜单对应的所有path路径
    paths: state => getPaths(state.user.resource, null),
    organization: state => state.user.organization,
    dataQueryOrganizationPrefix: state => state.user.dataQueryOrganizationPrefix,
    userId: state => state.user.userId,
    mainPage: state => state.user.mainPage,
    idcard: state => state.user.idcard,
    organizationPrefix: state => getOrganizationPrefix(state),
    other: state => state.other,
    pageSize: state => state.searchParams.pageSize,
    //是否存在菜单资源，resourceCode为资源代码，多用于页面功能性按钮的权限控制，比如删除按钮，修改按钮等。例子：this.$store.haveResource('xxx')
    haveResource: state => {
      return (resourceCode: any) => {
        var resourceTemp = state.user.resource
        if (!resourceTemp) {
          return false
        }
        var resource = getResourceByCode(resourceCode, resourceTemp, null)
        if (resource && resource.length >= 1) {
          return true
        }
        return false
      }
    },
    //是否存在菜单资源名，name为资源名称，通过名称判断只在本菜单下生效。即在当前菜单下是否存在此资源名称的授权资源。例子：this.$store.haveResourceByName('新增')
    haveResourceByName: state => {
      //在当前菜单下的名称
      return (name: any, strict: Boolean) => {
        return haveBtnResourceByNameOnPath(state, name, strict)
      }
    },
    // 当前菜单下是否存在新增授权资源。例子：this.$store.haveAddBtn
    haveAddBtn: state => haveBtnResourceByNameOnPath(state, '新增'),
    // 当前菜单下是否存在修改,编辑授权资源。例子：this.$store.haveEditBtn
    haveEditBtn: state => haveBtnResourceByNameOnPath(state, '修改,编辑'),
    // 当前菜单下是否存在删除,注销授权资源。例子：this.$store.haveDeleteBtn
    haveDeleteBtn: state => haveBtnResourceByNameOnPath(state, '删除,注销'),
    // 是否存在角色。例子：this.$store.hasRole('ROLE_ADMIN')
    hasRole: state => {
      return (role: any) => {
        return hasRole(state, role)
      }
    },
    // 是否存在多个角色中的一个。例子：this.$store.hasRoles('ROLE_ADMIN,ROLE_SUPERADMIN')
    hasRoles: state => {
      return (roles: any) => {
        return hasRoles(state, roles)
      }
    }
  }
})

// token cookies get方法
function getToken() {
  return Cookies.get(TokenKey) || ''
}

// token cookies set方法
function setToken(token: string) {
  return Cookies.set(TokenKey, token)
}

// token cookies remove方法
function removeToken() {
  Cookies.remove(TokenKey)
}

// i18n cookies获取语言类型并实现
function getI18nLocale() {
  i18n.locale = Cookies.get(I18nLocaleKey) || ''
  return Cookies.get(I18nLocaleKey) || ''
}

// i18n cookies设置语言类型并实现
function setI18nLocale(locale: string) {
  i18n.locale = locale
  Cookies.set(I18nLocaleKey, locale)
}

//获取用户组织机构前缀
function getOrganizationPrefix(state: any) {
  if (!state.user.organization) {
    return ''
  }
  if (hasRole(state, 'ROLE_SUPERADMIN')) {
    return ''
  } else if (hasRole(state, 'ROLE_ADMIN_LEVEL3') || hasRole(state, 'ROLE_LEVEL3USER')) {
    return '31'
  } else if (hasRole(state, 'ROLE_ADMIN_LEVEL4') || hasRole(state, 'ROLE_LEVEL4USER')) {
    return state.user.organization.substring(0, 6)
  } else if (hasRole(state, 'ROLE_ADMIN_LEVEL5') || hasRole(state, 'ROLE_LEVEL5USER')) {
    return state.user.organization
  } else if (state.user.organization.startsWith('310000')) {
    return '31'
  } else if (state.user.organization.endsWith('000000')) {
    return state.user.organization.substring(0, 6)
  } else {
    return state.user.organization
  }
}

//是否存在角色
function hasRole(state: any, role: any) {
  return state.user.roles && state.user.roles.indexOf(role) > -1
}

//是否存在角色,roles逗号分割
function hasRoles(state: any, role: any) {
  if (!state.user.roles || !role) {
    return false
  }
  var roles: Array<any> = state.user.roles
  var intelligentRoles: Array<any> = role.split(',')
  return roles.some(item => intelligentRoles.some(item2 => item2 === item))
}

// 获取资源菜单对应的所url路径
function getPaths(resources: any, paths: any) {
  if (!paths) {
    paths = []
  }
  resources.forEach((element: any) => {
    if (element.path) {
      paths.push(element.path)
    }
    if (element.children) {
      getPaths(element.children, paths)
    }
  })
  return paths
}

//在当前path下，通过名称获取是否拥有权限
function haveBtnResourceByNameOnPath(state: any, names: any, strict: Boolean = false) {
  var path = location.href.split('#')[1]
  if (strict === false) {
    path = path.split('?')[0]
  }
  var resource = getResourceByPath(state.user.resource, path, null)
  if (!resource.children || resource.children.length == 0) {
    return true
  }
  if (resource.children && resource.children.some((item: any) => names.split(',').some((name: any) => name === item.name))) {
    return true
  }
  return false
}

// 获取此路径对应下的菜单资源
function getResourceByPath(resources: any, path: any, resource: any) {
  if (resource == null) {
    resource = {}
  }
  if (Object.keys(resource).length > 1) {
    return resource
  }
  for (let index = 0; index < resources.length; index++) {
    const element = resources[index]
    if (element.href && element.href === path && element.href.indexOf(path) > -1) {
      Object.assign(resource, element)
      break
    }
    if (element.children) {
      getResourceByPath(element.children, path, resource)
    }
  }
  return resource
}

// //根据代码获取对应的菜单组
function getResourceByCode(code: String, resources: Array<any>, result: any) {
  if (!result) {
    result = []
  }
  resources.forEach(element => {
    if (element.code === code) {
      result.push(element)
    }
    if (element.children) {
      getResourceByCode(code, element.children, result)
    }
  })
  return result
}
